<template lang='pug'>
.page-wrapper
    Navbar
    .content-wrapper
        Loader(v-if='isLoading')
        .content
            span(v-html='content.content')
            span(v-if='!content.content && !isLoading') Nothing here. :(

    Footer
</template>

<style lang='stylus' scoped>
@import "../../stylus/mixins.styl";

.content-wrapper
    flexbox(column, center, center)
    margin 30px 300px

    @media (max-width: 1200px) 
        margin 30px 10px
        overflow auto
    padding 20px
    background-color white
    img
        width 300px
        self-align center

    .image
        text-align center

</style>

<script>
import Navbar from '../components/Navbar';
import Loader from '../components/Loader';
import Footer from '../components/Footer';

export default {
    components: {
        Navbar,
        Loader,
        Footer,
    },

    metaInfo() {
        return {
            title: this.title,
        };
    },

    props: {
        typeFilter: String,
    },

    data() {
        return {
            title: "",
            isLoading: false,
            content: {},
        };
    },

    async mounted() {
        this.isLoading = true;
        const response = await window.axios.get(`/api/content/${this.$route.params.slug}`);
        this.content = response.data;
        this.title = this.content.title;
        this.isLoading = false;
    },

};
</script>
